export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5107.8ca8a586.jpg";